module.exports = __webpack_public_path__ + "static/img/101397.04400aee.png";